import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import './styles/global.css' // 引入全局样式

const app = createApp(App)

// 注册 Vant 组件
app.use(Vant)

app.use(router)
app.mount('#app')
